module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/DiamondSolidSmall.32c2211a.svg";